import React from 'react';

import Container from 'pisces/components/Container';

import Loader from '../icons/Loader';

const StateLoading = () => (
  <Container className="page-loading loading">
    <Container className="loader-container">
      <Loader />
    </Container>
  </Container>
);

export default StateLoading;
